import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useWeb3Context } from "hooks";
import styled from 'styled-components'
import { Flex, useMatchBreakpoints, Button, Link, Grid, Text } from '@crystals/uikit'
import { DEFAULD_NETWORK } from "../../../../constants";


const MenuButton = styled(Button)`
  background: #b07efa;
  text-align: center;
  box-shadow: 1px 1px 5px 1px rgb(14 14 44 / 19%);
  
  height: 50px;
  padding: 15px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background-color: #00e0b8;
  font-family: Biennale, sans-serif;
  color: #07071c;
  font-size: 17px;
  line-height: 1;
  font-weight: 500;
  &:hover {
    opacity: 0.7;
  }
`

function ConnectWallet() {
    const { connect, disconnect, connected, web3, providerChainID, checkWrongNetwork, address } = useWeb3Context();
    const dispatch = useDispatch();
    const [isConnected, setConnected] = useState(connected);

    let buttonText = "ConnectWallet";
    let clickFunc: any = connect;
    let buttonStyle = {};

    if (isConnected) {
        buttonText = `${String(address).substring(0, 6)}...${String(address).substring(38)}`;
        clickFunc = disconnect;
    }

    if (isConnected && providerChainID !== DEFAULD_NETWORK) {
        buttonText = "Wrong Network";
        buttonStyle = { backgroundColor: "rgb(255, 67, 67)", color: "#ffffff" };
        clickFunc = () => {
            checkWrongNetwork();
        };
    }

    useEffect(() => {
        setConnected(connected);
    }, [web3, connected]);

    return (
        <MenuButton size="md"  style={buttonStyle} onClick={clickFunc}>
            <p>{buttonText}</p>
        </MenuButton>
    );
}

export default ConnectWallet;
